// extracted by mini-css-extract-plugin
export default {"signinastext":"SignUpForm_signinastext__-uR7o","signintype":"SignUpForm_signintype__AUXDa","signupp":"SignUpForm_signupp__xkPSr"};